var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.08 18.126"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 14.567l5.9 3.558-1.565-6.707 5.205-4.511-6.859-.582L9.54 0 6.859 6.325 0 6.907l5.209 4.512-1.565 6.707z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "0a752a8e67d94490557833d0de4783ee.svg";
export { SvgStar as ReactComponent };